// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url(colors.css); */

.loader {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 100%;
	align-content: center;
	min-width: 200px;
	min-height: 200px;
}

.icon-menu-non-mobile {
	position: relative;
	background-color: black;
}
.map-container {
	display: flex;
	flex-direction: column;
	margin-top: 0rem;
	border-radius: 0.7rem;
	align-self: center;
	width: 100%;
	/* height: 267.25px;  */
}

.error-message {
	font-size: 1.2rem;
	box-shadow: 0px 0px 4px 2px;
	padding: 1rem;
	border-radius: 0.7rem;
}

.spacer-more {
	min-height: 0rem;
}

.my-map {
	opacity: 1;
	padding: 0rem;
	margin: 0px;
}



@media (min-width: 500px) {

	
	.map-container {
		width: 100%;
	}
	.icon-menu-non-mobile {
		display: flex;

		/* position: relative; */
		background-color: black;
	}

	.loader {
		min-height: 20rem;
	}
}
/*
@media (min-width: 500px) and (max-height: 415px) {
  .floaties-container {
    min-width: 100vw;
    flex-direction: row;
    padding: 0rem;
    margin: 0rem;
    justify-content: space-evenly;
    background-color: transparent;
    max-width: 100%;
    align-items: center;
  }

  .content-container {
    flex-direction: column;
    justify-content: space-evenly;
    width: 100%;
    height: 100%;
    max-height: 100%;
    text-align: left;
    align-self: strech;
    padding: 0rem 0.5rem;
    align-items: flex-end;
    margin: 1rem 1rem;
  }
  .content-container.inner-content {
    align-self: center;
    margin-top: 3rem;
  }
  .map-container {
    flex-grow: 1;
    margin-left: 1rem;
    flex-direction: column;
    justify-content: flex-end;
  }
}
*/
`, "",{"version":3,"sources":["webpack://./src/components/LeftPanel/GeneralStyles/FloatPanel.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;CACC,aAAa;CACb,uBAAuB;CACvB,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,iBAAiB;CACjB,2BAA2B;CAC3B,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,aAAa;CACb,WAAW;AACZ;;;;AAIA;;;CAGC;EACC,WAAW;CACZ;CACA;EACC,aAAa;;EAEb,wBAAwB;EACxB,uBAAuB;CACxB;;CAEA;EACC,iBAAiB;CAClB;AACD;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAoCC","sourcesContent":["/* @import url(colors.css); */\n\n.loader {\n\tdisplay: flex;\n\tjustify-content: center;\n\twidth: 100%;\n\theight: 100%;\n\talign-content: center;\n\tmin-width: 200px;\n\tmin-height: 200px;\n}\n\n.icon-menu-non-mobile {\n\tposition: relative;\n\tbackground-color: black;\n}\n.map-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 0rem;\n\tborder-radius: 0.7rem;\n\talign-self: center;\n\twidth: 100%;\n\t/* height: 267.25px;  */\n}\n\n.error-message {\n\tfont-size: 1.2rem;\n\tbox-shadow: 0px 0px 4px 2px;\n\tpadding: 1rem;\n\tborder-radius: 0.7rem;\n}\n\n.spacer-more {\n\tmin-height: 0rem;\n}\n\n.my-map {\n\topacity: 1;\n\tpadding: 0rem;\n\tmargin: 0px;\n}\n\n\n\n@media (min-width: 500px) {\n\n\t\n\t.map-container {\n\t\twidth: 100%;\n\t}\n\t.icon-menu-non-mobile {\n\t\tdisplay: flex;\n\n\t\t/* position: relative; */\n\t\tbackground-color: black;\n\t}\n\n\t.loader {\n\t\tmin-height: 20rem;\n\t}\n}\n/*\n@media (min-width: 500px) and (max-height: 415px) {\n  .floaties-container {\n    min-width: 100vw;\n    flex-direction: row;\n    padding: 0rem;\n    margin: 0rem;\n    justify-content: space-evenly;\n    background-color: transparent;\n    max-width: 100%;\n    align-items: center;\n  }\n\n  .content-container {\n    flex-direction: column;\n    justify-content: space-evenly;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n    text-align: left;\n    align-self: strech;\n    padding: 0rem 0.5rem;\n    align-items: flex-end;\n    margin: 1rem 1rem;\n  }\n  .content-container.inner-content {\n    align-self: center;\n    margin-top: 3rem;\n  }\n  .map-container {\n    flex-grow: 1;\n    margin-left: 1rem;\n    flex-direction: column;\n    justify-content: flex-end;\n  }\n}\n*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
